export default "__VITE_ASSET__jnWmhnry__"